import apiClient, { ApiResponse } from '../api-client'

export interface AppConfig {
  isMaintenance: boolean
}

export const getAppConfig = async () => {
  const { data } = await apiClient.get<ApiResponse<AppConfig>>('/app-config')
  return data.data
}
